export const zinputPalettes: Record<string, string[]> = {
    pastel: [
        '#FF9AA2',
        '#BAFFC9',
        '#C7CEEA',
        '#FDFD96',
        '#CB99C9',
        '#FFDFBA',
        '#77DD77',
        '#A2D2FF',
        '#F49AC2',
        '#E2F0CB',
        '#B39EB5',
        '#FFB347',
        '#AAF0D1',
        '#FFC8DD',
        '#AEC6CF',
        '#FFFFBA',
        '#DEA5A4',
        '#B5EAD7',
        '#E0BBE4',
        '#FFDAC1',
        '#C1E1C1',
        '#BAE1FF',
        '#D4A5A5',
        '#D0F4DE',
        '#CDB4DB',
        '#FFB3BA',
        '#BDE0FE',
        '#F8C8DC',
        '#CFCFC4',
        '#FAF3DD',
    ],
    material: [
        '#F44336', // red 500
        '#4CAF50', // green 500
        '#2196F3', // blue 500
        '#FFEB3B', // yellow 500
        '#9C27B0', // purple 500
        '#FF9800', // orange 500
        '#009688', // teal 500
        '#E91E63', // pink 500
        '#8BC34A', // light green 500
        '#3F51B5', // indigo 500
        '#FFC107', // amber 500
        '#673AB7', // deep purple 500
        '#00BCD4', // cyan 500
        '#FF5722', // deep orange 500
        '#CDDC39', // lime 500
        '#03A9F4', // light blue 500
        '#795548', // brown 500
        '#607D8B', // blue grey 500
        '#9E9E9E', // grey 500
        '#D32F2F', // red 700
        '#388E3C', // green 700
        '#1976D2', // blue 700
        '#FBC02D', // yellow 700
        '#7B1FA2', // purple 700
        '#F57C00', // orange 700
        '#00796B', // teal 700
        '#C2185B', // pink 700
        '#689F38', // light green 700
        '#303F9F', // indigo 700
        '#0097A7', // cyan 700
    ],
}
